import { Droppable } from "react-beautiful-dnd";
import Page from "./Page";
import classNames from "classnames";
import ColumnHeader from "./ColumnHeader";
import GhostElement from "./GhostElement";
import { DRAG_AND_DROP_CONSTANTS } from "utils/dndBoard/constants";

const Column = (props) => {
  const {
    pages,
    column,
    draggableProps,
    dragHandleProps,
    innerRef,
    toggleSelection,
    toggleSelectionInGroup,
    multiSelectTo,
    draggingPageId,
    setPageToDisplay,
    disableDrag,
    saveHandler,
    pageIdsSelected,
    showComment,
    sortByPage,
  } = props;
  const { id, title } = column;

  const columnClasses = classNames(
    "py-1",
    "pl-1",
    "mr-2",
    "text-dark",
    "rounded",
    "dnd-column",
    disableDrag && "disable-drag",
    "border-2",
    `border-${
      id === DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE && pages.length
        ? "danger"
        : "transparent"
    }`
  );
  const listClasses = classNames(
    "dnd-column-list",
    disableDrag && "disable-drag"
  );

  return (
    <div ref={innerRef} {...draggableProps} className={columnClasses}>
      <ColumnHeader
        dragHandleProps={dragHandleProps}
        columnId={id}
        title={title}
        showComment={showComment}
        sortByPage={sortByPage}
        pages={pages}
      />
      <Droppable
        droppableId={id}
        type={DRAG_AND_DROP_CONSTANTS.PAGE}
        renderClone={(provided, _, rubric) => (
          <GhostElement
            provided={provided}
            pageNumber={pages[rubric.source.index].pageNumber}
            url={pages[rubric.source.index].url}
            pagesCount={pageIdsSelected?.length}
          />
        )}
      >
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className={listClasses}
          >
            {pages?.map((page, index) => {
              const isSelected = pageIdsSelected?.includes(page.id);
              const isGhosting =
                isSelected && draggingPageId && draggingPageId !== page.id;
              return (
                <Page
                  {...page}
                  key={page.id}
                  columnId={id}
                  index={index}
                  isSelected={isSelected}
                  isGhosting={isGhosting}
                  setPageToDisplay={setPageToDisplay}
                  multiSelectTo={multiSelectTo}
                  toggleSelection={toggleSelection}
                  toggleSelectionInGroup={toggleSelectionInGroup}
                  disableDrag={disableDrag}
                  saveHandler={saveHandler}
                />
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};

export default Column;
